var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.653H1M25 15.9863V11.053C25 8.81279 25 7.69268 24.564 6.83703C24.1805 6.08438 23.5686 5.47246 22.816 5.08897C21.9603 4.65299 20.8402 4.65299 18.6 4.65299H7.4C5.15979 4.65299 4.03969 4.65299 3.18404 5.08897C2.43139 5.47246 1.81947 6.08438 1.43597 6.83703C1 7.69268 1 8.81278 1 11.053V22.253C1 24.4932 1 25.6133 1.43597 26.469C1.81947 27.2216 2.43139 27.8335 3.18404 28.217C4.03969 28.653 5.15979 28.653 7.4 28.653H13M18.3333 1.98633V7.31966M7.66667 1.98633V7.31966M16.3333 24.653L19 27.3197L25 21.3197",
    stroke: "#1E1E1E",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.14585600b349e2d9ec165047090ca3fe.svg";
export { ForwardRef as ReactComponent };